import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function TransferButton({ callId }) {
  const [showPanel, setShowPanel] = useState(false);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transferring, setTransferring] = useState("");

  useEffect(() => {
    if (!showPanel) return;
    setLoading(true);
    api.get("/telephony/team-members-for-conference").then(({ data }) => setMembers(data)).catch(() => {}).finally(() => setLoading(false));
  }, [showPanel]);

  const doTransfer = async (uid, name) => {
    setTransferring(uid);
    try {
      const { data } = await api.post(`/telephony/call/${callId}/transfer`, { user_id: uid });
      if (data.success) {
        toast.success(`Call transferred to ${name}`);
        setShowPanel(false);
      } else {
        toast.error(data.error || "Transfer failed");
      }
    } catch (err) { toast.error(err?.response?.data?.detail || "Transfer failed"); }
    setTransferring("");
  };

  return (
    <div className="relative" data-testid="transfer-panel">
      <Button variant="outline" size="sm" className="gap-1 text-xs" onClick={() => setShowPanel(p => !p)} data-testid="transfer-btn">
        <ArrowRight size={14} /> Transfer
      </Button>
      {showPanel && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-[#1E293B] border border-[#E5E7EB] dark:border-[#334155] rounded-lg shadow-lg z-20 p-3">
          <div className="text-xs font-semibold text-[#0F172A] dark:text-[#F1F5F9] mb-2">Transfer call to</div>
          {loading ? <div className="text-xs text-[#9CA3AF] py-2">Loading...</div> : (
            <div className="max-h-[200px] overflow-y-auto space-y-1">
              {members.filter(m => m.has_extension).map(m => (
                <button key={m.id} onClick={() => doTransfer(m.id, m.name)} disabled={transferring === m.id}
                  className="w-full text-left flex items-center gap-2 px-2 py-1.5 rounded hover:bg-[#F3F4F6] dark:hover:bg-[#334155] text-xs transition-colors" data-testid={`transfer-member-${m.id}`}>
                  <div className="w-5 h-5 rounded-full bg-[#0F172A] flex items-center justify-center text-white text-[8px] font-bold">{m.name?.[0]}</div>
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-[#0F172A] dark:text-[#F1F5F9] truncate">{m.name}</div>
                    <div className="text-[9px] text-[#9CA3AF]">Ext. {m.extension} — {m.role?.replace("_", " ")}</div>
                  </div>
                  {transferring === m.id && <div className="w-3 h-3 border border-[#0F172A] border-t-transparent rounded-full animate-spin" />}
                </button>
              ))}
              {members.filter(m => m.has_extension).length === 0 && <div className="text-xs text-[#9CA3AF] py-2">No team members with extensions</div>}
            </div>
          )}
          <button onClick={() => setShowPanel(false)} className="mt-2 text-[10px] text-[#9CA3AF] hover:text-[#6B7280]">Close</button>
        </div>
      )}
    </div>
  );
}
